<template>
  <div>
    <!-- TripTotalKm -->
    <b-form-group
      :label="$t('tracking.cargo.tripTotalKm')"
      label-for="TripTotalKm"
    >
      <b-form-input
        type="number"
        id="TripTotalKm"
        :placeholder="$t('tracking.cargo.tripTotalKm')"
        v-model="model.tripTotalKm"
        @change="handleChange"
      />

      <span class="text-danger" v-if="modelstate['TripTotalKm']">
        {{ modelstate["TripTotalKm"][0] }}
      </span>
    </b-form-group>

    <!-- DateAttendance -->
    <b-form-group
      :label="$t('tracking.cargo.dateAttendance')"
      label-for="DateAttendance"
    >
      <b-form-input
        type="date"
        id="DateAttendance"
        :placeholder="$t('tracking.cargo.dateAttendance')"
        v-model="model.dateAttendance"
        :readonly="readonly"
        @change="handleChange"
      />

      <span class="text-danger" v-if="modelstate['DateAttendance']">
        {{ modelstate["DateAttendance"][0] }}
      </span>
    </b-form-group>

    <!-- horarioAttendance -->
    <b-form-group
      :label="$t('tracking.cargo.timeAttendance')"
      label-for="HourAttendance"
    >
      <b-form-input
        type="time"
        id="HourAttendance"
        :placeholder="$t('tracking.cargo.timeAttendance')"
        v-model="model.hourAttendance"
        :readonly="readonly"
        @change="handleChange"
      />

      <span class="text-danger" v-if="modelstate['HourAttendance']">
        {{ modelstate["HourAttendance"][0] }}
      </span>
    </b-form-group>

    <!-- DateDeliveryForecast -->
    <b-form-group
      :label="$t('tracking.cargo.dateDeliveryForecast')"
      label-for="DateDeliveryForecast"
    >
      <b-form-input
        type="date"
        id="DateDeliveryForecast"
        :placeholder="$t('tracking.cargo.dateDeliveryForecast')"
        v-model="model.dateDeliveryForecast"
        :readonly="readonly"
      />

      <span class="text-danger" v-if="modelstate['DateDeliveryForecast']">
        {{ modelstate["DateDeliveryForecast"][0] }}
      </span>
    </b-form-group>

    <!-- horarioDeliveryForecast -->
    <b-form-group
      :label="$t('tracking.cargo.timeDeliveryForecast')"
      label-for="HourDeliveryForecast"
    >
      <b-form-input
        type="time"
        id="HourDeliveryForecast"
        :placeholder="$t('tracking.cargo.timeDeliveryForecast')"
        v-model="model.hourDeliveryForecast"
        :readonly="readonly"
      />

      <span class="text-danger" v-if="modelstate['HourDeliveryForecast']">
        {{ modelstate["HourDeliveryForecast"][0] }}
      </span>
    </b-form-group>

    <!-- motivo de alteração da Data de Atendimento -->
    <b-form-group
      v-if="
        model.reasonForChangingTheAttendanceDate != null ||
        model.dateAttendanceChange != model.dateAttendance ||
        model.hourAttendanceChange != model.hourAttendance
      "
      :label="$t('tracking.cargo.reasonForChangingTheAttendanceDate')"
      label-for="ReasonForChangingTheAttendanceDate"
    >
      <b-form-input
        v-if="
          model.dateAttendanceChange != model.dateAttendance ||
          model.hourAttendanceChange != model.hourAttendance
        "
        type="text"
        id="ReasonForChangingTheAttendanceDate"
        :placeholder="$t('tracking.cargo.reasonForChangingTheAttendanceDate')"
        v-model="model.reasonForChangingTheAttendanceDate"
        :readonly="false"
      />

      <b-form-input
        v-else
        type="text"
        id="ReasonForChangingTheAttendanceDate"
        :placeholder="$t('tracking.cargo.reasonForChangingTheAttendanceDate')"
        v-model="model.reasonForChangingTheAttendanceDate"
        :readonly="true"
      />

      <span
        class="text-danger"
        v-if="modelstate['ReasonForChangingTheAttendanceDate']"
      >
        {{ modelstate["ReasonForChangingTheAttendanceDate"][0] }}
      </span>
    </b-form-group>
    <!-- <div>{{model.reasonForChangingTheAttendanceDate}}</div> -->
    <!-- <div>{{model.dateAttendanceChange}}</div> -->
    <!-- <div>{{modelstate}}</div> -->
    <!-- <div>{{model.hourAttendanceChange}}</div> -->
    <!-- <div>{{model.hourAttendance}}</div> -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
    create: Boolean,
  },
  methods: {
    loadDateDelivery(tripTotalKm, dateAttendance) {
      if (this.model.hourAttendance != undefined) {
        var obj = {
          tripTotalKm: tripTotalKm,
          serviceData: dateAttendance + "T" + this.model.hourAttendance,
        };
      } else {
        var obj = {
          tripTotalKm: tripTotalKm,
          serviceData: dateAttendance,
        };
      }
      this.$api
        .post("/cargo/dateDelivery", obj)
        .then((response) => {
          const dateTimeParts = response.data.split("T");
          this.model.dateDeliveryForecast = dateTimeParts[0];
          if (this.model.hourAttendance != undefined) {
            this.model.hourDeliveryForecast = dateTimeParts[1];
          }
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    handleChange() {
      if (this.model.tripTotalKm && this.model.dateAttendance != undefined) {
        this.loadDateDelivery(
          this.model.tripTotalKm,
          this.model.dateAttendance
        );
      }
    },
  },
};
</script>
